










import {
  Component,
  Vue,
} from 'vue-property-decorator';

import bLink from 'bootstrap-vue/es/components/link/link';

@Component({
  components: {
    bLink,
  },
})
export default class EmptyCartView extends Vue { }

